import { render, staticRenderFns } from "./PriceBandList.vue?vue&type=template&id=f366f4a4&scoped=true&"
import script from "./PriceBandList.vue?vue&type=script&lang=js&"
export * from "./PriceBandList.vue?vue&type=script&lang=js&"
import style0 from "./PriceBandList.vue?vue&type=style&index=0&id=f366f4a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f366f4a4",
  null
  
)

export default component.exports